import { HttpClient } from '@angular/common/http';
import { EventEmitter, Injectable } from '@angular/core';
import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DashboardService {
  readonly rootURL = environment.apiurl+"dashboard/";
  messageEvent = new EventEmitter();

  constructor(private http: HttpClient) { }
  
  getDashboardDetails(email:string):any {
    return this.http.get(this.rootURL+`dashboard`).toPromise();
  }
  emitSignal() {
    this.messageEvent.emit();
  }
}
